import React, {

  useEffect,

  useState,

} from "react";



import I from "./Icon";

import BC from "./Breadcrumb";

import apiService from "../services/apiService";



// =========================================================

// APIs

// =========================================================



const GET_TEACHER_BOOK_ASSIGN_BY_ID_API =

  "TeacherBookAssign/getTeacherBookAssignById";



const TEACHER_API =

  "Teacher/getAllTeacher";



const SCHOOL_API =

  "School/getAllSchool";



const BOOK_API =

  "BookMaster/getPaginatedBookMasters";



// =========================================================

// RESPONSE HELPERS

// =========================================================



const getResponseData = (response) =>

  response?.data ?? response;



const getOutput = (response) => {

  const data =

    getResponseData(response);



  return (

    data?.output ??

    data?.Output ??

    data?.data ??

    data?.Data ??

    data

  );

};



const extractList = (response) => {

  const data =

    getResponseData(response);



  if (Array.isArray(data)) {

    return data;

  }



  const output =

    data?.output ??

    data?.Output ??

    data?.data ??

    data?.Data ??

    data?.result ??

    data?.Result ??

    data;



  if (Array.isArray(output)) {

    return output;

  }



  const candidates = [

    output?.result,

    output?.Result,



    output?.items,

    output?.Items,



    output?.records,

    output?.Records,



    output?.rows,

    output?.Rows,



    output?.data,

    output?.Data,



    output?.list,

    output?.List,



    output?.teachers,

    output?.Teachers,



    output?.schools,

    output?.Schools,



    output?.books,

    output?.Books,



    output?.bookMasters,

    output?.BookMasters,

  ];



  return (

    candidates.find(

      Array.isArray

    ) || []

  );

};



// =========================================================

// ACTIVE

// =========================================================



const isActiveRecord = (item) => {

  const value =

    item?.isActive ??

    item?.IsActive ??

    item?.status ??

    item?.Status;



  if (

    value === undefined ||

    value === null

  ) {

    return true;

  }



  if (

    value === true ||

    value === 1 ||

    value === "1"

  ) {

    return true;

  }



  const text =

    String(value)

      .trim()

      .toLowerCase();



  return (

    text === "true" ||

    text === "active"

  );

};



// =========================================================

// TEACHER

// =========================================================



const normalizeTeacher = (

  teacher

) => {

  const id =

    teacher?.id ??

    teacher?.Id ??

    teacher?.teacherId ??

    teacher?.TeacherId ??

    0;



  const generatedName = [

    teacher?.firstName ??

      teacher?.FirstName,



    teacher?.middleName ??

      teacher?.MiddleName,



    teacher?.lastName ??

      teacher?.LastName,

  ]

    .filter(Boolean)

    .join(" ")

    .trim();



  const name =

    teacher?.fullName ??

    teacher?.FullName ??

    teacher?.teacherName ??

    teacher?.TeacherName ??

    teacher?.name ??

    teacher?.Name ??

    generatedName ??

    "";



  return {

    ...teacher,

    id,

    name,

  };

};



// =========================================================

// SCHOOL

// =========================================================



const normalizeSchool = (

  school

) => ({

  ...school,



  id:

    school?.id ??

    school?.Id ??

    school?.schoolId ??

    school?.SchoolId ??

    0,



  schoolName:

    school?.schoolName ??

    school?.SchoolName ??

    school?.name ??

    school?.Name ??

    school?.school ??

    "",

});



// =========================================================

// BOOK

// =========================================================



const normalizeBook = (

  book

) => ({

  ...book,



  id:

    book?.id ??

    book?.Id ??

    book?.bookId ??

    book?.BookId ??

    book?.bookMasterId ??

    book?.BookMasterId ??

    0,



  bookCode:

    book?.bookCode ??

    book?.BookCode ??

    "",



  bookName:

    book?.bookName ??

    book?.BookName ??

    "",



  amount:

    Number(

      book?.amount ??

      book?.Amount ??

      0

    ),

});



// =========================================================

// CREATE MAP

// =========================================================



const createMap = (list) => {

  const map = {};



  list.forEach((item) => {

    if (

      item?.id !==

        undefined &&

      item?.id !== null

    ) {

      map[

        String(item.id)

      ] = item;

    }

  });



  return map;

};



// =========================================================

// DETAIL

// =========================================================



const normalizeDetail = (

  item,

  bookMap = {},

  oldBook = null

) => {

  const bookId =

    item?.bookId ??

    item?.BookId ??

    0;



  const masterBook =

    bookMap[

      String(bookId)

    ];



  const oldDetail =

    Array.isArray(

      oldBook?.books

    )

      ? oldBook.books.find(

          (detail) =>

            String(

              detail?.bookId ??

                detail?.BookId ??

                ""

            ) ===

            String(bookId)

        )

      : null;



  const qty =

    Number(

      item?.qty ??

      item?.Qty ??

      item?.purchased ??

      item?.Purchased ??

      0

    );



  const returnQty =

    Number(

      item?.returnQty ??

      item?.ReturnQty ??

      item?.returnBooks ??

      item?.ReturnBooks ??

      0

    );



  const description =

    item?.description ??

    item?.Description ??

    item?.notes ??

    item?.Notes ??

    "";



  return {

    ...item,



    id:

      item?.id ??

      item?.Id ??

      0,



    assignBookId:

      item?.assignBookId ??

      item?.AssignBookId ??

      0,



    bookId,



    bookCode:

      item?.bookCode ||

      item?.BookCode ||

      masterBook?.bookCode ||

      oldDetail?.bookCode ||

      "",



    bookName:

      item?.bookName ||

      item?.BookName ||

      masterBook?.bookName ||

      oldDetail?.bookName ||

      "",



    amount:

      Number(

        item?.amount ??

        item?.Amount ??

        masterBook?.amount ??

        oldDetail?.amount ??

        0

      ),



    qty,



    purchased:

      qty,



    returnQty,



    returnBooks:

      returnQty,



    description,



    notes:

      description,



    isActive:

      item?.isActive ??

      item?.IsActive ??

      true,

  };

};



// =========================================================

// MAIN RECORD

// =========================================================



const normalizeRecord = (

  data,

  {

    teacherMap = {},

    schoolMap = {},

    bookMap = {},

    oldBook = {},

  } = {}

) => {

  const id =

    data?.id ??

    data?.Id ??

    data?.assignBookId ??

    data?.AssignBookId ??

    oldBook?.id ??

    0;



  const teacherId =

    data?.teacherId ??

    data?.TeacherId ??

    oldBook?.teacherId ??

    0;



  const schoolId =

    data?.schoolId ??

    data?.SchoolId ??

    oldBook?.schoolId ??

    0;



  const teacherMaster =

    teacherMap[

      String(teacherId)

    ];



  const schoolMaster =

    schoolMap[

      String(schoolId)

    ];



  // =======================================================

  // TEACHER NAME

  // =======================================================



  const teacherName =

    data?.teacherName ||

    data?.TeacherName ||

    (

      typeof data?.teacher ===

      "string"

        ? data.teacher

        : ""

    ) ||

    teacherMaster?.name ||

    oldBook?.teacher ||

    oldBook?.name ||

    "";



  // =======================================================

  // SCHOOL NAME

  // =======================================================



  const schoolName =

    data?.schoolName ||

    data?.SchoolName ||

    (

      typeof data?.school ===

      "string"

        ? data.school

        : ""

    ) ||

    schoolMaster?.schoolName ||

    oldBook?.school ||

    "";



  // =======================================================

  // DETAILS

  // =======================================================



  const rawDetails =

    data?.teaBooAssDetlst ??

    data?.TeaBooAssDetlst ??

    data?.teaBooAssDetLst ??

    data?.TeaBooAssDetLst ??

    data?.teacherBookAssignDetails ??

    data?.TeacherBookAssignDetails ??

    data?.details ??

    data?.Details ??

    [];



  const details =

    Array.isArray(

      rawDetails

    )

      ? rawDetails.map(

          (item) =>

            normalizeDetail(

              item,

              bookMap,

              oldBook

            )

        )

      : [];



  // =======================================================

  // DATE

  // =======================================================



  const documentDate =

    data?.documentDate ??

    data?.DocumentDate ??

    data?.purchaseDate ??

    data?.PurchaseDate ??

    oldBook?.documentDate ??

    oldBook?.purchaseDate ??

    "";



  // =======================================================

  // STUDENTS

  // =======================================================



  const studentCount =

    Number(

      data?.studentCount ??

      data?.StudentCount ??

      data?.students ??

      data?.Students ??

      oldBook?.studentCount ??

      oldBook?.students ??

      0

    );



  // =======================================================

  // TOTAL PURCHASED

  // =======================================================



  const purchased =

    details.length > 0

      ? details.reduce(

          (

            total,

            item

          ) =>

            total +

            Number(

              item?.qty ??

              0

            ),

          0

        )

      : Number(

          data?.booksPurchased ??

          data?.purchased ??

          oldBook?.booksPurchased ??

          oldBook?.purchased ??

          0

        );



  // =======================================================

  // RETURNED

  // =======================================================



  const returned =

    details.length > 0

      ? details.reduce(

          (

            total,

            item

          ) =>

            total +

            Number(

              item?.returnQty ??

              0

            ),

          0

        )

      : Number(

          data?.returnBooks ??

          data?.returnQty ??

          oldBook?.returnBooks ??

          0

        );



  // =======================================================

  // DESCRIPTION

  // =======================================================



  const description =

    data?.description ??

    data?.Description ??

    data?.notes ??

    oldBook?.description ??

    oldBook?.notes ??

    "";



  return {

    ...oldBook,

    ...data,



    id,



    assignBookId:

      id,



    teacherId,



    teacher:

      teacherName,



    name:

      teacherName,



    schoolId,



    school:

      schoolName,



    competitiveExams: data?.competitiveExams ?? data?.CompetitiveExams ?? oldBook?.competitiveExams ?? oldBook?.CompetitiveExams ?? "",

    deliveryMethod: data?.deliveryMethod ?? data?.DeliveryMethod ?? oldBook?.deliveryMethod ?? oldBook?.DeliveryMethod ?? "",

    documentDate,



    purchaseDate:

      documentDate,



    studentCount,



    students:

      studentCount,



    description,



    notes:

      description,



    totalAmount:

      Number(

        data?.totalAmount ??

        data?.TotalAmount ??

        oldBook?.totalAmount ??

        0

      ),



    purchased,



    booksPurchased:

      purchased,



    returnBooks:

      returned,



    books:

      details,



    teaBooAssDetlst:

      details,



    isActive:

      data?.isActive ??

      data?.IsActive ??

      true,

  };

};



// =========================================================

// COMPONENT

// =========================================================



export default function BookView({

  book,

  onBack,

  onEdit,

}) {

  const [

    data,

    setData,

  ] = useState(

    book || null

  );



  const [

    loading,

    setLoading,

  ] = useState(

    false

  );



  const [

    error,

    setError,

  ] = useState(

    ""

  );



  // =======================================================

  // ID

  // =======================================================



  const recordId =

    book?.id ??

    book?.Id ??

    book?.assignBookId ??

    book?.AssignBookId ??

    0;



  // =======================================================

  // LOAD VIEW

  // =======================================================



  useEffect(() => {

    if (!recordId) {

      return;

    }



    let cancelled =

      false;



    const loadData =

      async () => {

        try {

          setLoading(

            true

          );



          setError(

            ""

          );



          // ===============================================

          // GET BY ID

          // ===============================================



          const response =

            await apiService.get(

              `${GET_TEACHER_BOOK_ASSIGN_BY_ID_API}/${recordId}`

            );



          if (

            cancelled

          ) {

            return;

          }



          const result =

            getResponseData(

              response

            );



          console.log(

            "Teacher Book View Response:",

            result

          );



          const success =

            result?.isSuccess ??

            result?.IsSuccess ??

            true;



          if (

            success === false

          ) {

            throw new Error(

              result?.failureReason ??

              result?.FailureReason ??

              result?.message ??

              result?.Message ??

              "Unable to load record"

            );

          }



          const output =

            getOutput(

              response

            );



          const record =

            output?.result ??

            output?.Result ??

            output;



          if (

            !record ||

            typeof record !==

              "object" ||

            Array.isArray(record)

          ) {

            throw new Error(

              "Record not found"

            );

          }



          // ===============================================

          // MASTER DATA

          // ===============================================



          const [

            teacherResponse,

            schoolResponse,

            bookResponse,

          ] =

            await Promise.allSettled([

              apiService.get(

                TEACHER_API

              ),



              apiService.get(

                SCHOOL_API

              ),



              apiService.post(

                BOOK_API,

                {

                  Page: 1,



                  PageSize:

                    1000,



                  SearchTerm:

                    "",



                  SortDirection:

                    "ASC",



                  SortField:

                    "BookName",



                  IsActive:

                    true,



                  IncludeInActive:

                    false,

                }

              ),

            ]);



          if (

            cancelled

          ) {

            return;

          }



          // ===============================================

          // TEACHERS

          // ===============================================



          const teachers =

            teacherResponse.status ===

            "fulfilled"

              ? extractList(

                  teacherResponse.value

                )

                  .filter(

                    isActiveRecord

                  )

                  .map(

                    normalizeTeacher

                  )

              : [];



          // ===============================================

          // SCHOOLS

          // ===============================================



          const schools =

            schoolResponse.status ===

            "fulfilled"

              ? extractList(

                  schoolResponse.value

                )

                  .filter(

                    isActiveRecord

                  )

                  .map(

                    normalizeSchool

                  )

              : [];



          // ===============================================

          // BOOKS

          // ===============================================



          const books =

            bookResponse.status ===

            "fulfilled"

              ? extractList(

                  bookResponse.value

                )

                  .filter(

                    isActiveRecord

                  )

                  .map(

                    normalizeBook

                  )

              : [];



          // ===============================================

          // MAPS

          // ===============================================



          const teacherMap =

            createMap(

              teachers

            );



          const schoolMap =

            createMap(

              schools

            );



          const bookMap =

            createMap(

              books

            );



          // ===============================================

          // FINAL DATA

          // ===============================================



          const normalized =

            normalizeRecord(

              record,

              {

                teacherMap,

                schoolMap,

                bookMap,



                oldBook:

                  book || {},

              }

            );



          console.log(

            "Teacher Book View Final:",

            normalized

          );



          if (

            cancelled

          ) {

            return;

          }



          setData(

            normalized

          );

        } catch (err) {

          if (

            cancelled

          ) {

            return;

          }



          console.error(

            "View Error:",

            err

          );



          const apiError =

            err?.response

              ?.data;



          const message =

            typeof apiError ===

            "string"

              ? apiError

              : apiError?.failureReason ??

                apiError?.FailureReason ??

                apiError?.message ??

                apiError?.Message ??

                err?.message ??

                "Unable to load record";



          setError(

            String(message)

          );

        } finally {

          if (

            !cancelled

          ) {

            setLoading(

              false

            );

          }

        }

      };



    loadData();



    return () => {

      cancelled =

        true;

    };



    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [

    recordId,

  ]);



  // =======================================================

  // EMPTY

  // =======================================================



  if (!book) {

    return null;

  }



  // =======================================================

  // LOADING

  // =======================================================



  if (loading) {

    return (

      <>

        <BC

          items={[

            "Books",

            "View Book Record",

          ]}

          onBack={

            onBack

          }

        />



        <div

          className="card cp"

          style={{

            maxWidth:

              680,



            padding:

              40,



            textAlign:

              "center",



            color:

              "var(--t3)",

          }}

        >

          Loading book details...

        </div>

      </>

    );

  }



  // =======================================================

  // ERROR

  // =======================================================



  if (error) {

    return (

      <>

        <BC

          items={[

            "Books",

            "View Book Record",

          ]}

          onBack={

            onBack

          }

        />



        <div

          className="card cp"

          style={{

            maxWidth:

              680,

          }}

        >

          <div

            style={{

              color:

                "#ef4444",



              marginBottom:

                15,

            }}

          >

            {error}

          </div>



          <button

            type="button"

            className="btn btn-g"

            onClick={

              onBack

            }

          >

            Back

          </button>

        </div>

      </>

    );

  }



  if (!data) {

    return null;

  }



  const detailBooks =

    Array.isArray(

      data.books

    )

      ? data.books

      : [];



  // Read-only View uses the same field grouping/order as Add Book Record.
  const description = String(data.description ?? data.notes ?? "");
  const deliveryMatch = description.match(/^\[Delivery Method: (Courier|Shop Pickup)\](?:\s*\|\s*)?/);
  const deliveryMethod = data.deliveryMethod || deliveryMatch?.[1] ||
    (detailBooks.some((item) => Number(item.courierCharges || 0) > 0) ? "Courier" : "");
  const displayNotes = description.replace(/^\[Delivery Method: (?:Courier|Shop Pickup)\](?:\s*\|\s*)?/, "");
  const examName = String(data.competitiveExams ?? data.CompetitiveExams ?? data.examName ?? "").trim();
  const money = (amount) => `₹${Number(amount || 0).toLocaleString("en-IN")}`;
  const readOnly = (label, value, full = false, type = "text") => (
    <div className={`fg${full ? " fall" : ""}`}>
      <label className="fl">{label}</label>
      <input className="fi" type={type} value={value ?? ""} readOnly disabled />
    </div>
  );
  const viewTotals = detailBooks.reduce((totals, item) => {
    totals.subtotal += Number(item.amount || 0) * Number(item.qty ?? item.purchased ?? 0);
    totals.courier += Number(item.courierCharges || 0);
    return totals;
  }, { subtotal: 0, courier: 0 });

  return (
    <>
      <BC items={["Books", "View Book Record"]} onBack={onBack} />
      <div className="card cp" style={{ maxWidth: 680 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18, gap: 12 }}>
          <div style={{ fontWeight: 700, fontSize: 15 }}>View Book Record</div>
          {onEdit && <button type="button" className="btn btn-g btn-sm" onClick={() => onEdit(data)}>
            <I n="edit" s={12} /> Edit
          </button>}
        </div>

        <div className="fsec">
          <div className="fsec-t"><I n="teacher" s={14} c="var(--p)" /> Assignment</div>
          <div className="fgrid">
            {readOnly("Assign to Teacher", data.teacher || data.name || "-")}
            {readOnly("School", data.school || "-")}
            {readOnly("Competitive Exam", examName || "-")}
            {readOnly("Total Student Count", data.studentCount ?? data.students ?? "-")}
            {readOnly("Delivery Method", deliveryMethod === "Shop Pickup" ? "Pick Up from Store" : (deliveryMethod || "-"), true)}
            {deliveryMethod === "Courier" && (
              <div className="fg fall" role="note" style={{ fontSize: 12, color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 6, padding: "8px 10px" }}>
                Note: A courier charge of ₹50 per book is included in the total amount.
              </div>
            )}
            <div className="fg fall">
              <label className="fl">Notes</label>
              <textarea className="fi" rows={2} value={displayNotes} readOnly disabled />
            </div>
          </div>
        </div>

        <div className="fsec">
          <div className="fsec-t" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <I n="book" s={14} c="var(--p)" /> Book Information
          </div>
          {examName && (
            <div style={{ padding: "11px 13px", marginBottom: 14, background: "#eff6ff", borderRadius: 8, fontSize: 12, color: "#1e40af" }}>
              <strong>{examName}</strong> — {detailBooks.length} assigned book(s)
              {!!detailBooks.length && <div style={{ marginTop: 6, color: "#334155" }}>
                {detailBooks.map((item) => item.bookName).filter(Boolean).join(", ")}
              </div>}
            </div>
          )}
          {detailBooks.length ? detailBooks.map((item, index) => {
            const qty = Number(item.qty ?? item.purchased ?? 0);
            const amount = Number(item.amount || 0);
            const courier = Number(item.courierCharges || 0);
            const returnBooks = Number(item.returnQty ?? item.returnBooks ?? 0);
            const purchaseDate = String(item.purchaseDate || item.documentDate || data.documentDate || data.purchaseDate || "").slice(0, 10);
            return (
              <div key={item.id || `${item.bookId}-${index}`} style={{ border: "1px solid #e5e7eb", borderRadius: "var(--r3)", padding: 14, marginBottom: 14, background: "#fff" }}>
                <div style={{ fontSize: 12.5, fontWeight: 700, color: "var(--t2)", marginBottom: 13 }}>Book {index + 1}</div>
                <div className="fgrid">
                  {readOnly("Book Name", item.bookName ? `${item.bookName}${item.bookCode ? ` - ${item.bookCode}` : ""}` : `Book ID: ${item.bookId}`, true)}
                  {readOnly("Purchase Date", purchaseDate, false, "date")}
                  {readOnly("Qty Purchased", qty, false, "number")}
                  {readOnly("Student Count", item.students ?? item.studentCount ?? data.studentCount ?? data.students ?? "-")}
                  {readOnly("Return Books", returnBooks, false, "number")}
                  {readOnly("Notes", item.notes || item.description || "-")}
                </div>
                <div style={{ marginTop: 10, fontSize: 12, color: "var(--t3)" }}>
                  Book Amount: <strong style={{ color: "var(--t2)" }}>{money(amount)}</strong>
                  {courier > 0 && <> {" • "} Courier: <strong>{money(courier)}</strong></>}
                  {" • "} Total: <strong style={{ color: "var(--p)" }}>{money(amount * qty + courier)}</strong>
                </div>
              </div>
            );
          }) : <div style={{ padding: 20, textAlign: "center", color: "var(--t3)" }}>No book details found</div>}
          {!!detailBooks.length && <div style={{ marginBottom: 18, fontSize: 13, textAlign: "right", fontWeight: 600 }}>
            Books: {money(viewTotals.subtotal)} {" • "} Courier: {money(viewTotals.courier)} {" • "}
            Total Amount: <strong style={{ color: "var(--p)" }}>{money(data.totalAmount ?? viewTotals.subtotal + viewTotals.courier)}</strong>
          </div>}
        </div>
        <div style={{ display: "flex", gap: 9 }}>
          {onEdit && <button type="button" className="btn btn-p" onClick={() => onEdit(data)}>
            <I n="edit" s={13} c="#fff" /> Edit Book Record
          </button>}
          <button type="button" className="btn btn-g" onClick={onBack}>Back</button>
        </div>
      </div>
    </>
  );
}
